import { SmartTable } from '../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor() {
		this.st= new SmartTable();
    }

    $onInit() {
        const format = date => new Date(date).toString().slice(4, 24);
        this.sharedFolders.forEach(sharedFolder => sharedFolder.createdOnDisplay = format(sharedFolder.createdOn));
    }

}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-folders/shared-folders.controller.js